export const useStyles = (theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    paddingTop: 30,
    paddingBottom: 30,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down(960)]: {
      padding: 10,
    },
  },
});
